import { parse } from './helpers/querystring';
import isObject from './shared/isObject';
import { decode } from './urlSafeBase64';
import enhancedSessionStorage from './enhancedSessionStorage';

const sessionStorageKey = 'initial-params';

const { search, hash } = location;

if (hash.length || search.length) {
  clearUrlParams();
}

let initialParams = loadInitialParams(search.slice(1), hash.slice(1));

function loadInitialParams(search: string, hash: string) {
  if (search.length || hash.length) {
    let params = { ...parseParams(search), ...parseParams(hash) };
    enhancedSessionStorage.set(sessionStorageKey, params);
    return params;
  } else {
    let params = enhancedSessionStorage.get(sessionStorageKey);
    return isObject(params) ? params : {};
  }
}

function parseParams(string: string): ObjectOf<JSONValue> {
  let { _params: encodedParams, ...otherParams } = parse(string);
  let parsed: JSONValue | undefined;
  // The following logic allows us to embed deeply nested objects in the query-
  // string using JSON encoding followed by URL-safe base64 encoding.
  if (typeof encodedParams === 'string') {
    try {
      parsed = JSON.parse(decode(encodedParams));
    } catch (e) {}
  }
  return isObject(parsed) ? { ...otherParams, ...parsed } : otherParams;
}

export function getInitialParams(): ObjectOf<JSONValue> {
  return initialParams;
}

export function updateInitialParams(
  updater: (params: ObjectOf<JSONValue>) => ObjectOf<JSONValue>,
) {
  initialParams = updater(initialParams);
  enhancedSessionStorage.set(sessionStorageKey, initialParams);
}

function clearUrlParams() {
  if (history.replaceState) {
    history.replaceState({}, document.title, location.pathname);
  }
}

export { parseParams as parseParamsForTesting };
